import { useState, useEffect, useRef } from 'react';
import { Button } from '../primitives';
import { useDatabase } from '../../contexts/DatabaseContext';
import { useTranslation } from '../../hooks/useTranslation';

export default function FileUploadSettings({ workspaceId, workspaceType, setConfig, allowedFileTypes, setAllowedFileTypes, hasChangesFileUpload }) {
    const FILE_TYPES = ['.jpg', '.png', '.gif', '.svg', '.bmp', '.pdf', '.doc', '.docx', '.csv', '.xlsx', '.xls', '.txt', '.ppt', '.pptx', '.mp3', '.mp4'];
    const [loading, setLoading] = useState(false);
    const { updateWorkspaceConfigDoc, createFileUploadActionEvent } = useDatabase();
    const t = useTranslation();
    const [buttonText, setButtonText] = useState(t('Update Settings'));

    const handleSubmit = async () => {
        try {
            setLoading(true);
            createFileUploadActionEvent(workspaceType, workspaceId, allowedFileTypes);
            await updateWorkspaceConfigDoc(workspaceId, { allowedFileTypes });
            setConfig(prev => ({ ...prev, allowedFileTypes }));
        } catch (error) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    message: "An error occurred while updating the workspace config.",
                    action: "file_upload",
                }
            }));
        } finally {
            setLoading(false);
            setButtonText('Published!');
            setTimeout(() => {
                setButtonText('Update Settings');
            }, 2000);
        }
    }

    return (
        <div className="file-type-container">            
            <div className="file-type-group">
                <div className="file-type-category">
                    <h4>File Types</h4>
                    <div className="file-type-extensions">
                        {FILE_TYPES.map((ext, idx) => {
                            const isChecked = allowedFileTypes?.includes(ext);
                            return (
                                <div key={idx} className="extension-item">
                                    <input
                                        type="checkbox"
                                        id={`file-${ext}`}
                                        className="extension-checkbox"
                                        checked={isChecked}
                                        onChange={() => {
                                            const newTypes = isChecked
                                                ? allowedFileTypes.filter(t => t !== ext)
                                                : [...allowedFileTypes, ext];
                                            setAllowedFileTypes(newTypes);
                                        }}
                                    />
                                    <label className="extension-button" htmlFor={`file-${ext}`}>
                                        {ext}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <Button className="submit settings" 
                onClick={handleSubmit} 
                loading={loading}
                loadingFinish={buttonText === 'Published!'}
                disabled={!hasChangesFileUpload}
            >
                {buttonText}
            </Button>
        </div>
    );
}